import { render, staticRenderFns } from "./xxzp.vue?vue&type=template&id=7c0d9021&scoped=true&"
import script from "./xxzp.vue?vue&type=script&lang=js&"
export * from "./xxzp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0d9021",
  null
  
)

export default component.exports